import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import Logo from '../../Logo/Logo.js';
import RootSVG from './Loader.styles.js';

var DEFAULT_TRANSITION_DURATION = '150ms';
var LOGO_SIZE = 400;
var DIMENSIONS = {
  HEIGHT: 900,
  WIDTH: 1600
};
var CENTRE = {
  X: DIMENSIONS.WIDTH / 2 - LOGO_SIZE / 2,
  Y: DIMENSIONS.HEIGHT / 2 - LOGO_SIZE / 2
};
var Loader = function Loader(_ref) {
  var _ref$finished = _ref.finished,
    finished = _ref$finished === void 0 ? false : _ref$finished,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$transitionDurati = _ref.transitionDuration,
    transitionDuration = _ref$transitionDurati === void 0 ? DEFAULT_TRANSITION_DURATION : _ref$transitionDurati;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    transitionFinished = _useState2[0],
    setTransitionFinished = _useState2[1];
  var theme = useTheme();
  var handleTransitionEnd = function handleTransitionEnd() {
    setTransitionFinished(true);
  };
  useEffect(function () {
    if (!finished) setTransitionFinished(false);
  }, [finished]);
  return !transitionFinished ? React__default.createElement(RootSVG, {
    $finished: finished,
    "data-testid": testId,
    onTransitionEnd: handleTransitionEnd,
    $transitionDuration: transitionDuration,
    viewBox: "0 0 ".concat(DIMENSIONS.WIDTH, " ").concat(DIMENSIONS.HEIGHT),
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement(Logo, {
    animate: loading,
    colour: theme.applyOpacity(theme.colours.canvas.secondary.ink, 'overlay'),
    height: LOGO_SIZE,
    x: CENTRE.X,
    y: CENTRE.Y,
    width: LOGO_SIZE
  })) : null;
};
Loader.propTypes = {
  finished: PropTypes.bool,
  loading: PropTypes.bool,
  testId: PropTypes.string,
  transitionDuration: PropTypes.string
};

export { Loader };
//# sourceMappingURL=Loader.js.map
